import Axios from "axios";

export const searchReceiptApprovalApi = ({
    authToken,
    deviceId,
    merchantId,
    username,
    mobileNumber,
    startDate,
    endDate,
    page,
    pageSize
}) => {
    if (!authToken) return;
    return Axios({
        method: "get",
        url: window.ApiURL + "point/receipt",
        params: {
            memberId: "",
            merchantId: merchantId || "",
            username: username || "",
            mobileNumber: mobileNumber || "",
            startDate: startDate || "",
            endDate: endDate || "",
            page: page || 0,
            pageSize: pageSize || 10
        },
        headers: {
            "Content-Type": "application/json",
            authToken,
            deviceUniqueId: deviceId
        }
    });
};

export const viewReceiptApprovalApi = ({ authToken, deviceId, merchantId, id }) => {
    if (!authToken) return;
    return Axios({
        method: "get",
        url: window.ApiURL + "point/receipt/" + id,
        params: { merchantId },
        headers: {
            "Content-Type": "application/json",
            authToken,
            deviceUniqueId: deviceId
        }
    });
};

export const postReceiptApprovalApi = ({
    authToken,
    deviceId,
    receiptId,
    status,
    rejectionReasons,
    amount
}) => {
    if (!authToken) return;
    return Axios({
        method: "put",
        url: window.ApiURL + "point/receipt",
        data: {
            receiptId,
            status,
            rejectionReasons: rejectionReasons || "",
            amount: String(amount)
        },
        headers: {
            "Content-Type": "application/json",
            authToken,
            deviceUniqueId: deviceId
        }
    });
};

export const calculateReceiptApi = ({ authToken, deviceId, receiptId, merchantId, amount }) => {
    if (!authToken) return;
    return Axios({
        method: "post",
        url: window.ApiURL + "point/receipt/calculate",
        data: { receiptId, merchantId, amount: String(amount) },
        headers: {
            "Content-Type": "application/json",
            authToken,
            deviceUniqueId: deviceId
        }
    });
};
